import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

const HIGHLIGHT_SLUGS = [
    "sarees",
    "blouses",
    "lehengas",
    "kurtis-kurta-sets",
    "anarkali",
    "gowns",
    "indo-western",
    "dupattas",
];

const FEATURED_SLUGS = ["sarees", "blouses"];

export function FeaturedCollections() {
    const [cats, setCats] = useState([]);

    useEffect(() => {
        api.get("/categories")
            .then(({ data }) => {
                const map = new Map(data.map((c) => [c.slug, c]));
                const ordered = HIGHLIGHT_SLUGS.map((s) => map.get(s)).filter(Boolean);
                setCats(ordered);
            })
            .catch(() => setCats([]));
    }, []);

    if (!cats.length) return null;

    return (
        <section className="bg-beige py-16 lg:py-24" data-testid="featured-collections">
            <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-10">
                    <div>
                        <span className="label-eyebrow">The Edit</span>
                        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl text-inkDark tracking-tight">Featured collections</h2>
                    </div>
                    <p className="text-inkMuted max-w-md">
                        From everyday weaves to ceremonial showpieces &mdash; explore the categories defining the season.
                    </p>
                </div>

                <div className="flex gap-5 overflow-x-auto no-scrollbar pb-2 -mx-6 px-6 lg:mx-0 lg:px-0 lg:grid lg:grid-cols-4 lg:gap-6">
                    {cats.map((c, i) => {
                        const featured = FEATURED_SLUGS.includes(c.slug);
                        return (
                            <Link
                                key={c.slug}
                                to={`/category/${c.slug}`}
                                className={
                                    "group min-w-[240px] lg:min-w-0 relative rounded-2xl overflow-hidden bg-ivory transition-shadow " +
                                    (featured
                                        ? "shadow-lift ring-2 ring-skyblueDeep/60 hover:shadow-lift"
                                        : "shadow-soft hover:shadow-lift")
                                }
                                data-testid={`featured-collection-${c.slug}`}
                                data-featured={featured ? "true" : undefined}
                                style={{ animationDelay: `${i * 60}ms` }}
                            >
                                {featured ? (
                                    <span className="absolute top-3 right-3 z-10 label-eyebrow text-[10px] px-2.5 py-1 rounded-full bg-skyblueDeep text-white tracking-[0.14em]">
                                        Featured
                                    </span>
                                ) : null}
                                <div className="aspect-[4/5] overflow-hidden">
                                    <img
                                        src={c.imageUrl}
                                        alt={c.name}
                                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="p-5">
                                    <div className="font-serif text-xl text-inkDark group-hover:text-skyblueDeep transition-colors">{c.name}</div>
                                    <div className="label-eyebrow mt-1 text-[10px]">Shop now</div>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
